document.querySelectorAll( '.e-stn--platform-features-cards .swiper-wrapper a' ).forEach( function( anchor ) {
  const href = anchor.getAttribute( 'href' );
  if ( !href || href === '#' ) {
    anchor.addEventListener( 'click', function( event ) {
      event.preventDefault();
    } );                
  }    
} );
